export default {
    install (Vue) {
        Object.defineProperty(Vue.prototype, '$roles', {
            get () {
                return [
                    {
                        name: 'Superuser', id: 2
                    },
                    {
                        name: 'Regional Manager', id: 3
                    },
                    {
                        name: 'Tech Support', id: 4
                    },
                    {
                        name: 'Photographer, Salesforce', id: 5
                    },
                    {
                        name: 'Restaurateur', id: 6
                    },
                    {
                        name: 'Restaurant Manager', id: 7
                    },
                    {
                        name: 'Restaurant KDS', id: 8
                    },
                    {
                        name: 'Restaurant Server A+', id: 9
                    },
                    {
                        name: 'Restaurant Manager Assistant', id: 10
                    },
                    {
                        name: 'Restaurant Server A', id: 11
                    },
                    {
                        name: 'Restaurant Server B', id: 12
                    },
                ]
            }
        })
    }
}
